import React, { FC } from 'react'

export const CardTitle: FC = ({ children }): JSX.Element => <div className='card-container__title'>{children}</div>
